import { useState } from 'react';
import { Button } from '../design/primitives';
import { useStore } from '../state/store';

/**
 * The gate on the hosted deployment.
 *
 * Presented as a bank sign-in rather than an apologetic password prompt: it is
 * the first thing a prospect sees, and it should already look like the product
 * they were promised. One field, no branding gymnastics.
 */
export function SignIn() {
  const { signIn } = useStore();
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string>();
  const [busy, setBusy] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    if (busy || !password) return;

    setBusy(true);
    setError(undefined);
    try {
      await signIn(password);
    } catch (cause) {
      setError((cause as Error).message);
      setBusy(false);
    }
  }

  return (
    <div className="mb-gate">
      <form className="mb-gate__card" onSubmit={submit}>
        <span className="mb-gate__mark" aria-hidden>
          M
        </span>
        <h1 className="mb-gate__title">Meridian Bank</h1>
        <p className="mb-gate__subtitle">
          Operations console — a guided demonstration of FullCourtDefense running against a fictional bank.
        </p>

        <label className="mb-gate__field">
          <span>Access password</span>
          <input
            className="mb-input"
            type="password"
            autoFocus
            autoComplete="current-password"
            value={password}
            onChange={event => setPassword(event.target.value)}
            aria-invalid={error ? true : undefined}
            aria-describedby={error ? 'mb-gate-error' : undefined}
          />
        </label>

        {error && (
          <p className="mb-gate__error" id="mb-gate-error" role="alert">
            {error}
          </p>
        )}

        <Button type="submit" variant="primary" disabled={busy || !password}>
          {busy ? 'Opening console…' : 'Enter the console'}
        </Button>

        <p className="mb-gate__note">
          Everything beyond this point is fictional — no real customer data, no real hosts, and no command reaches a
          real shell.
        </p>
      </form>
    </div>
  );
}
